import React, {Component} from 'react';
import NavBar from "./NavBar";
import Footer from "./Footer";

class Product extends Component {

    componentDidMount(){
        document.title = "RigChecks - product";
    }

    render() {
        return (
            <div>
                <NavBar/>

                <Footer/>
            </div>
        )
    }

}

export default Product;




// WEBPACK FOOTER //
// ./src/component/Product.js